import { ref, readonly } from 'vue'

const _windowWidth = ref(window.innerWidth)
export const windowWidth = readonly(_windowWidth)
export function updateWindowWidth(width: number) {
  _windowWidth.value = width
}

const _screenHeight = ref(window.innerHeight)
export const screenHeight = readonly(_screenHeight)
export function updateScreenHeightFromVisualViewport() {
  const vv = window.visualViewport
  if (vv && vv.scale !== 1) {
    _screenHeight.value = Math.round(vv.height * vv.scale)
  }
}
export function updateScreenHeightFromInnerHeight() {
  _screenHeight.value = window.innerHeight
}

const _screenWidth = ref(window.innerWidth)
export const screenWidth = readonly(_screenWidth)
export function updateScreenWidthFromVisualViewport() {
  const vv = window.visualViewport
  if (vv && vv.scale !== 1) {
    _screenWidth.value = Math.round(vv.width * vv.scale)
  }
}
export function updateScreenWidthFromInnerWidth() {
  _screenWidth.value = window.innerWidth
}

const _slideshowSpeed = ref(
  parseInt(localStorage.getItem('slideshowSpeed') ?? '8000', 10)
)
export const slideshowSpeed = readonly(_slideshowSpeed)
export function setSlideshowSpeed(ms: number) {
  _slideshowSpeed.value = ms
  localStorage.setItem('slideshowSpeed', String(ms))
}

const _subPageTitle = ref('')
export const subPageTitle = readonly(_subPageTitle)
export function setSubPageTitle(title: string) {
  _subPageTitle.value = title
  document.title = (title ? title + ' - ' : '') + 'Network Gallery'
}

